var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.999939C4.67157 0.999939 4 1.67151 4 2.49994V21.4999C4 22.3284 4.67157 22.9999 5.5 22.9999H18.5C19.3284 22.9999 20 22.3284 20 21.4999V6.99994L14 0.999939H5.5Z",
    fill: "#6491CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22.9999C4.67157 22.9999 4 22.3284 4 21.4999V21.2499C4 22.0784 4.67157 22.7499 5.5 22.7499H18.5C19.3284 22.7499 20 22.0784 20 21.2499V21.4999C20 22.3284 19.3284 22.9999 18.5 22.9999H5.5Z",
    fill: "#417EE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.999939C4.67157 0.999939 4 1.67151 4 2.49994V2.74994C4 1.92151 4.67157 1.24994 5.5 1.24994H14.25L14 0.999939H5.5Z",
    fill: "#639AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 12.1251V7.00006L19.1247 6.12506H14.905C14.571 6.12506 14.4036 6.52899 14.6399 6.76523L19.9997 12.1251Z",
    fill: "url(#paint0_linear_911_1795)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.999939L20 6.99994H15.5C14.6716 6.99994 14 6.32837 14 5.49994V0.999939Z",
    fill: "#A6C5FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H8V13H16V12Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H8V15H16V14Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H16V17H8V16Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H8V19H14V18Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_1795",
    x1: 16.9997,
    y1: 12.1251,
    x2: 16.9997,
    y2: 6.00006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D6ACD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOtherIcon);
export default __webpack_public_path__ + "static/media/fileOtherIcon.fe8cd7d6355a245d4be1ba168a1834b8.svg";
export { ForwardRef as ReactComponent };